import type { FC } from 'react';
import React from 'react';

import type { LinkType, OnboardLinkFormProps } from '../../link/types';
import { useFlagsWithOverrides } from '../../../hooks/useFlagsWithOverrides';
import { CreateCustomLinkForm } from '../../link/CreateCustomLinkForm';
import { OnboardIncreaseLinkForm } from '../../link/OnboardIncreaseLinkForm';
import { OnboardStripeLinkForm } from '../../link/OnboardStripeLinkForm';
import { OnboardUnitLinkForm } from '../../link/OnboardUnitLinkForm';

const routes: Record<LinkType, FC<OnboardLinkFormProps>> = {
  IncreaseLink: OnboardIncreaseLinkForm,
  CustomLink: CreateCustomLinkForm,
  UnitLink: OnboardUnitLinkForm,
  StripeLink: OnboardStripeLinkForm,
};

const LINK_TYPES: LinkType[] = [
  'IncreaseLink',
  'UnitLink',
  'CustomLink',
  'StripeLink',
];

export const useEnabledLinkTypes = (): LinkType[] => {
  const flags = useFlagsWithOverrides([
    'unit-integration-enabled',
    'stripe-integration-enabled',
  ]);
  return LINK_TYPES.filter(
    (type) =>
      (type !== 'UnitLink' || flags['unit-integration-enabled'].enabled) &&
      (type !== 'StripeLink' || flags['stripe-integration-enabled'].enabled)
  );
};

export type Props = {
  linkType: LinkType;
  onCreate: VoidFunction;
};
export const AddLinkView = ({ linkType, onCreate }: Props) => {
  const Component = routes[linkType];
  return (
    <Component
      {...{
        onCreate,
      }}
    />
  );
};
